/**
 * Single source of truth for URL strings. Never inline route literals in
 * components — read from here.
 */

export const ROUTES = {
  landing: '/',
  /**
   * Safe placeholder route — destination for the landing Hero/Conviction
   * primary CTA ("Register for free"). Real registration flow lands in
   * `feat/web-auth-entry-points`; until then this route renders a
   * `<PageStatus>` placeholder. No form, no data collection, no backend call.
   */
  register: '/register',
  /**
   * Safe placeholder route — destination for the landing Hero/Conviction
   * secondary CTA ("View plans"). Real pricing/plans surface lands in
   * `feat/web-pricing-plans-model`; until then this route renders a
   * `<PageStatus>` placeholder.
   */
  plans: '/plans',
  app: {
    root: '/app',
    profile: '/app/profile',
    /** Universal self-service account screen (profile, password, avatar). */
    account: '/app/account',
    // Reserved PRD modules — navigable "what's this feature" previews until
    // the real surfaces ship. Tier A (rich previews): smartProfile, jobMatches,
    // applications. Tier B (lightweight placeholders): company, settings,
    // analytics, integrations.
    smartProfile: '/app/smart-profile',
    jobMatches: '/app/job-matches',
    applications: '/app/applications',
    employer: '/app/employer',
    company: '/app/company',
    companyApplications: '/app/company/applications',
    companyCandidates: '/app/company/candidates',
    companyProfile: '/app/company/profile',
    settings: '/app/settings',
    analytics: '/app/analytics',
    integrations: '/app/integrations',
    // Admin OS
    admin: '/app/admin',
    adminUsers: '/app/admin/users',
    adminRoles: '/app/admin/roles',
    adminSettings: '/app/admin/settings',
    adminAiUsage: '/app/admin/ai-usage',
    adminPlans: '/app/admin/plans',
    adminEarlyAccess: '/app/admin/early-access',
    adminAuditLogs: '/app/admin/audit-logs',
  },
  auth: {
    login: '/auth/login',
    register: '/auth/register',
    callback: '/auth/callback',
  },
  /** Public invitation accept / welcome page (token in the query string). */
  inviteAccept: '/invite/accept',
  unauthorized: '/unauthorized',
  serviceDown: '/service-down',
  notFound: '*',
} as const;
